import { useRef, useEffect } from "react";
import bwipjs from "bwip-js";

export type BarcodeGeneratorProps = {
    data: string;
};

export const BarcodeGenerator = ({ data }: BarcodeGeneratorProps) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (!canvasRef.current) return;
        try {
            bwipjs.toCanvas(canvasRef.current, {
                bcid: "datamatrix",
                text: data,
                scale: 100,
                height: 10,
                includetext: false,
            });
        } catch (error) {
            console.error("Error generating barcode:", error);
        }
    }, [data]);

    return <canvas ref={canvasRef} style={{width: 100, height: 100, marginLeft: 25, marginBottom: 25 }} />;
};
